// Red-team #27: orbit visual must reflect what we ship Day 1, not the Day-365 dream.
// Today: WhatsApp + PAN + GST + e-Sign are real. Aadhaar/MCA21/ONDC are roadmap.
// Anything in the orbit ships within 90 days; we add roadmap items as we earn them.
const orbitIcons = [
  { label: 'WA', color: 'text-[#25D366]', position: 'top-0 left-1/2 -translate-x-1/2' },
  { label: 'GST', color: 'text-saffron-600', position: 'top-1/2 right-0 -translate-y-1/2' },
  { label: 'eSign', color: 'text-violet-600', position: 'bottom-0 left-1/2 -translate-x-1/2' },
  { label: 'PAN', color: 'text-gold-700', position: 'top-1/2 left-0 -translate-y-1/2' },
];

export function IntegrationsOrbit() {
  return (
    <div className="w-[240px] h-[240px] relative flex items-center justify-center">
      <div
        className="absolute w-full h-full border border-dashed border-white/20 rounded-full animate-orbit-cw"
        aria-hidden="true"
      />
      <div
        className="absolute w-[70%] h-[70%] border border-dashed border-white/20 rounded-full animate-orbit-ccw"
        aria-hidden="true"
      />

      <div className="w-[72px] h-[72px] rounded-full bg-white flex items-center justify-center text-ink-900 font-display font-extrabold text-[28px] shadow-[0_0_0_8px_rgba(255,255,255,0.05)] relative z-[2] -tracking-[0.04em]">
        M
        <span
          className="absolute -bottom-1 -right-1 w-3.5 h-3.5 rounded-full bg-saffron-500"
          aria-hidden="true"
        />
      </div>

      {orbitIcons.map((icon) => (
        <div
          key={icon.label}
          className={`absolute w-[42px] h-[42px] rounded-md bg-white flex items-center justify-center text-[10px] font-bold shadow-card ${icon.color} ${icon.position}`}
        >
          {icon.label}
        </div>
      ))}
    </div>
  );
}
